import styled from "styled-components";

export const Container = styled.section`
  display: flex;
`;

export const Image = styled.img`
  width: 100%;
  border-bottom: 5px solid #1a3458;
`;

export const ImageOne = styled(Image)`
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const ImageResponsive = styled(Image)`
  display: none;

  @media (max-width: 1024px) {
    display: block;
  }
`;
